import React, {Component} from "react"
import {observer} from "mobx-react"
import styles from "./table.module.css"
import {api_response, Sort} from "lib/gate/interfaces"
import {Line} from "./parts/line"
import {Preloader} from "./parts/preloader"
import {HeaderButton} from "./parts/header-button"
import {ArrowType} from "./parts/header-button/header-button"
import {Gate} from "lib/gate/Gate"

const TABLE_STRUCTURE: Column[] = [
    {title: "ID", id: "id", server_id: "id"},
    {title: "Student Name", id: "full_name", server_id: "first_name"},
    {title: "Milestone`s name", id: "milestone_name", server_id: "name"},
    {title: "Status", id: "status", server_id: "status"},
    {title: "Created At", id: "created_at", server_id: "created_at"},
    {title: "Reached At", id: "reached_at", server_id: "reached_at"}
]

interface Props {
    gate: Gate
    items: api_response.Milestone[]
    isLoading: boolean
    sort: Sort
    onChange: (sort: Sort) => void
}

export interface Column {
    title: string
    id: string
    server_id: string
}

@observer
export class Table extends Component<Props, {}> {
    public render() {
        const tableStructure = TABLE_STRUCTURE
        const {items, isLoading, onChange, sort, gate} = this.props

        return (
            <div className={styles.tableWrapper}>
                {isLoading && <Preloader />}
                <table className={styles.table}>
                    <tbody>
                        <TableHeader tableStructure={tableStructure} onChange={onChange} sort={sort} />
                        {items.map((item: api_response.Milestone) => {
                            return (
                                <Line
                                    key={item.id}
                                    item={item}
                                    token={gate.getToken()}
                                    tableStructure={tableStructure}
                                />
                            )
                        })}
                    </tbody>
                </table>
            </div>
        )
    }
}

interface TableHeaderProps {
    sort: Sort
    tableStructure: Column[]
    onChange: (sort: Sort) => void
}

class TableHeader extends React.Component<TableHeaderProps, {}> {
    public render() {
        const {tableStructure, sort} = this.props
        return (
            <tr className={styles.headerLine}>
                {tableStructure.map((column: Column) => {
                    let type: ArrowType = null
                    if (column.server_id === sort.orderBy) {
                        type = sort.order
                    }
                    return (
                        <th className={styles.headerCell} key={column.title}>
                            <HeaderButton
                                title={column.title}
                                onClick={(type: ArrowType) => {
                                    this.props.onChange({orderBy: column.server_id, order: type})
                                }}
                                type={type}
                            />
                        </th>
                    )
                })}
            </tr>
        )
    }
}
